export { default as FreeSearchInput } from './FreeSearchInput.vue';
